import React from 'react'
import { Link } from 'react-router-dom';

function Home() {
    return (
        <>
            <div className="lg:py-10 lg:px-10 py-0 px-6">
                <div className="flex flex-col items-center">

                    <div className="lg:max-w-6xl px-4 py-6 justify-center items-center">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 justify-center items-center">
                            <div tabindex="0" style={{ transform: 'none' }}>
                                <div className="group flex flex-col h-[16rem] rounded-xl transition" >
                                    <div className="relative overflow-hidden">
                                        <div style={{ opacity: '1', transform: 'none' }}>
                                            <div className="p-6 flex-grow">
                                                <ul className="font-sans list-none pl-6 space-y-3 text-gray-700 my-4">
                                                    <li className="font-semibold">
                                                        <Link to="/cpa-coaching-india"> Cpa Coaching India</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/cpa-course-fees-in-india">Cpa Course Fees in india</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/cpa-review-course">KC GlobEd
                                                            CPA Review Course</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/us-enrolled-agent-courses">US Enrolled Agent Course</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div tabindex="0" style={{ transform: 'none' }}>
                                <div className="group flex flex-col h-[16rem] rounded-xl transition" >
                                    <div className="relative overflow-hidden">
                                        <div style={{ opacity: '1', transform: 'none' }}>
                                            <div className="p-6 flex-grow">
                                                <ul className="font-sans list-none pl-6 space-y-3 text-gray-700 my-4">
                                                    <li className="font-semibold">
                                                        <Link to="/us-enrolled-agent-classes-traning"> Enrolled Agent Classes</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/us-enrolled-agent-exam-centers-in-india"> Enrolled Agent Exam</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/us-cpa-study-materials-syllabus"> Cpa Study Materials</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/us-enrolled-agent-fees-in-india"> Enrolled Agent Course Fees</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div tabindex="0" style={{ transform: 'none' }}>
                                <div className="group flex flex-col h-[16rem] rounded-xl transition" >
                                    <div className="relative overflow-hidden">
                                        <div style={{ opacity: '1', transform: 'none' }}>
                                            <div className="p-6 flex-grow">
                                                <ul className="font-sans list-none pl-6 space-y-3 text-gray-700 my-4">
                                                    <li className="font-semibold">
                                                        <Link to="/us-enrolled-agent-salary"> EA Agent Salary</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/us-enrolled-agent-review-course"> Exam Review Courses</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/us-cpa-exam-requirement"> Us Cpa Exam Requirements</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/us-enrolled-agent-exam-preparation-course"> Ea Exam Prepration</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div tabindex="0" style={{ transform: 'none' }}>
                                <div className="group flex flex-col h-[16rem] rounded-xl transition" >
                                    <div className="relative overflow-hidden">
                                        <div style={{ opacity: '1', transform: 'none' }}>
                                            <div className="p-6 flex-grow">
                                                <ul className="font-sans list-none pl-6 space-y-3 text-gray-700 my-4">
                                                    <li className="font-semibold">
                                                        <Link to="/us-enrolled-agent-study-materials-syllabus"> Ea Study Materials</Link>
                                                    </li>
                                                    <li className="font-semibold">
                                                        <Link to="/us-cpa-salary"> Us Cpa Salary</Link>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Home;
